import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coca-cola-page',
  templateUrl: './coca-cola-page.component.html',
  styleUrls: ['./coca-cola-page.component.scss'],
})
export class CocaColaPageComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
